import type { QueryClient } from '@tanstack/react-query';

/** Событие для инвалидации кэша главной (dashboard home) после WS `notification.new`. */
export const PWA_DASHBOARD_HOME_INVALIDATE_EVENT = 'ppc:dashboard-home-invalidate';

/** После корректировки времени / force-close: главная, смены сегодня, календарь смен. */
export function invalidatePwaDashboardShiftCaches(queryClient: QueryClient): void {
  void queryClient.invalidateQueries({ queryKey: ['dashboard', 'home'] });
  void queryClient.invalidateQueries({ queryKey: ['dashboard', 'todayShifts'] });
  void queryClient.invalidateQueries({ queryKey: ['shifts'] });
}
